import { FC } from "react";
import Link from "next/link";
import S from "./index.module.scss";

type breadcrumbType = {
  title: string;
  url?: string;
};

interface IBreadcrumbs {
  breadcrumbs: breadcrumbType[];
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ breadcrumbs }) => {
  return (
    <div className={S.breadcrumbsWrap}>
      {breadcrumbs.map(breadcrumb =>
        breadcrumb.url ? (
          <Link className={S.breadcrumb} href={breadcrumb.url} key={breadcrumb.title}>
            {breadcrumb.title}
          </Link>
        ) : (
          <span className={S.breadcrumbText} key={breadcrumb.title}>
            {breadcrumb.title}
          </span>
        ),
      )}
    </div>
  );
};

export default Breadcrumbs;
